import Dialog          from './Dialog';
import AttributeDialog from './AttributeDialog';
import AlertDialog from './AlertDialog';
import ConfirmDialog from './ConfirmDialog';



export default {
  Dialog,
  AttributeDialog,
  AlertDialog,
  ConfirmDialog,
}



// WEBPACK FOOTER //
// ./src/js/ui/components/dialogs/index.js